var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { RemoveCustomFieldRepository } from '../repositories/remove-custom-field-repository.interface';
let RemoveCustomFieldServiceImpl = class RemoveCustomFieldServiceImpl {
    constructor(_removeCustomFieldRepository) {
        this._removeCustomFieldRepository = _removeCustomFieldRepository;
    }
    remove(customFieldIds) {
        return this._removeCustomFieldRepository.removeCustomField(customFieldIds);
    }
};
RemoveCustomFieldServiceImpl = __decorate([
    injectable(),
    __param(0, inject(RemoveCustomFieldRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof RemoveCustomFieldRepository !== "undefined" && RemoveCustomFieldRepository) === "function" ? _a : Object])
], RemoveCustomFieldServiceImpl);
export { RemoveCustomFieldServiceImpl };
